import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initAtcPopup from './components/atc-popup';
import initLazyloadVideo from './utils/lazyloadVideo';
import initHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initMinicart from './components/minicart';
import initAtcForm from './components/atcForm';
import initQuickBuyDrawer from './components/quick-buy-drawer';
import initCollectionCardVideo from './components/collection-card-video';
import initFeaturedProducts from './components/featured-products';
import initCollectionFinder from './components/collection-finder';
import initFaqs from './sections/faqs/faqs';
import initMultiContent from './sections/multi-content/multiContent';

ready(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initMinicart();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initAtcForm();
  initAtcPopup();
  initQuickBuyDrawer();
  initCollectionCardVideo();
  initFeaturedProducts();
  initCollectionFinder();
  initFaqs();
  initMultiContent();
});

onShopifySectionLoad(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initHeader();
  initLazyloadVideo();
  initMinicart();
  initAtcForm();
  initFeaturedProducts();
  initCollectionFinder();
  initFaqs();
  initMultiContent();
});
